<template>
  <div class="club-page container-fluid mt-5">
    <!-- Título principal -->
    <div class="page-header text-center mb-4">
      <h1 class="page-title">
        <font-awesome-icon icon="fas fa-users" class="me-2" /> {{ club.nombre }}
      </h1>
    </div>

    <!-- Barra de navegación -->
    <nav class="navbar navbar-expand-lg bg-light mb-4">
      <div class="container-fluid justify-content-center">
        <!-- Botones de navegación -->
        <button
          @click="seleccionarComponente('listarSalas')"
          class="btn btn-outline-primary me-3"
        >
          <font-awesome-icon icon="house" class="me-2" />
          Mis Salas o Espacios
        </button>
        <button
          @click="seleccionarComponente('listarGeneticas')"
          class="btn btn-outline-primary me-3"
        >
          <font-awesome-icon icon="fas fa-seedling" class="me-2" />
          Mis Genéticas
        </button>
        <button
          @click="seleccionarComponente('detallesClub')"
          class="btn btn-outline-primary"
        >
          <font-awesome-icon icon="info-circle" class="me-2" />
          Info del Club
        </button>
      </div>
    </nav>

    <!-- Contenido dinámico según el componente seleccionado -->
    <div class="content-container mt-4">
      <!-- Info del Club -->
      <div v-if="componenteActivo === 'detallesClub'" class="card shadow-sm">
        <div class="card-header">
          <h4>
            <font-awesome-icon icon="info-circle" class="me-2" />
            Detalles del Club
          </h4>
        </div>
        <div class="card-body">
          <p><strong>Nombre:</strong> {{ club.nombre }}</p>
          <p><strong>Descripción:</strong> {{ club.descripcion }}</p>
          <p><strong>Fecha de creación:</strong> {{ club.fundacion }}</p>
          <p><strong>Dirección:</strong> {{ club.direccion }}</p>
        </div>
      </div>

      <!-- Listar Salas de Cultivo -->
      <ListarSalasDeCultivo
        v-if="componenteActivo === 'listarSalas'"
        @editarSala="seleccionarComponente('editarSala', $event)"
        :club_id="club_id"
      />

      <!-- Listar Genéticas -->
      <ListarGeneticas
        v-if="componenteActivo === 'listarGeneticas'"
        :club_id="club_id"
      />

      <!-- Editar Sala de Cultivo -->
      <editarSalaDeCultivo
        v-if="componenteActivo === 'editarSala'"
        :club_id="club_id"
        :sala="salaEnAccion"
        @accionTerminada="seleccionarComponente('listarSalas')"
      />

      <!-- Aquí podrías agregar otros componentes (como eliminar sala, configurar puntos, etc.) -->
    </div>
  </div>
</template>

<script>
import axios from '@/axios';
import ListarSalasDeCultivo from '../salaDeCultivo/listar-salasDeCultivo.vue';
import ListarGeneticas from '../Genetica/listar-geneticas.vue';
import editarSalaDeCultivo from '../salaDeCultivo/editar-salaDeCultivo.vue';

export default {
  props: {
    club_id: {
      type: Number,
      required: true,
    },
  },
  components: {
    ListarSalasDeCultivo,
    ListarGeneticas,
    editarSalaDeCultivo,
  },
  data() {
    return {
      club: {}, // Datos del club
      componenteActivo: 'detallesClub', // Componente activo por defecto
      salaEnAccion: null, // Sala seleccionada para editar u otras acciones
    };
  },
  watch: {
    club_id: {
      immediate: true,
      handler(newId) {
        this.cargarClub(newId); // Cargar datos del club cuando cambia el ID
        this.seleccionarComponente('detallesClub'); // Mostrar detalles del club por defecto
      },
    },
  },
  methods: {
    async cargarClub(id) {
      try {
        const response = await axios.get(`/api/clubes/${id}`);
        this.club = response.data;
      } catch (error) {
        console.error('Error al obtener los detalles del club:', error);
      }
    },
    /**
     * Cambia el componente activo y, opcionalmente, asigna la sala en acción.
     * @param {String} nombre - Nombre del componente a mostrar.
     * @param {Object|null} sala - (Opcional) Sala que se enviará al componente.
     */
    seleccionarComponente(nombre, sala = null) {
      this.componenteActivo = nombre;
      this.salaEnAccion = sala;
    },
  },
};
</script>









<style scoped>
/* Contenedor general de la página */
.club-page {
  padding: 40px 20px;
  background-color: #f7f8fa;
  min-height: 100vh;
}

/* Título principal */
.page-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #333;
}

/* Barra de navegación personalizada */
.navbar {
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.btn-outline-primary {
  padding: 10px 20px;
  border-radius: 30px;
  font-size: 1rem;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.btn-outline-primary:hover {
  background-color: var(--app-primary);
  color: #fff;
}

/* Contenedor de las tarjetas de contenido */
.content-container {
  max-width: 1000px;
  margin: 0 auto;
}

.card {
  border-radius: 10px;
  border: none;
}

.card-header {
  background-color: #f8f9fa;
  border-bottom: none;
  padding: 15px;
}

.card-body {
  padding: 20px;
  font-size: 1rem;
}

.card-footer {
  padding: 15px;
}

.shadow-sm {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
</style>
